import { Controller } from '@hotwired/stimulus'

// "Match my Smart menu": fills the enclosing form's color inputs from SiteThemePalette (input name => hex)
// and fires their own input/change events, so a live preview repaints. Nothing saves until the form does.
export default class extends Controller {
  static targets = ['status']
  static values = { palette: Object }

  apply() {
    const form = this.element.closest('form')
    if (!form) return

    Object.entries(this.paletteValue).forEach(([name, hex]) => {
      const input = form.querySelector(`input[name="${name}"]`)
      if (!input) return

      input.value = hex
      input.dispatchEvent(new Event('input', { bubbles: true }))
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
    if (this.hasStatusTarget) this.statusTarget.hidden = false
  }
}
